const values = [1, 2, 3, 4, 5];

// For numeric-10 aka NPS
const numeric10Values = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export { numeric10Values as n, values as v };
//# sourceMappingURL=values-D-xU0n7p.js.map
